import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICancellationPolicy } from "../cancellationpolicyModel";

export const getAllCancellationPolicy = createAsyncThunk(
  "CancellationPolicies/FindAllCancellationPolicies",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CancellationPolicies/FindAllCancellationPolicies`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CancellationPolicy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCancellationPolicy = createAsyncThunk(
  "CancellationPolicies/InsertCancellationPolicies",
  async (CancellationPolicyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CancellationPolicies/InsertCancellationPolicies`,
        CancellationPolicyData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating CancellationPolicy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCancellationPolicy = createAsyncThunk(
  "CancellationPolicies/UpdateCancellationPolicies",
  async (CancellationPolicyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CancellationPolicies/UpdateCancellationPolicies`,
        CancellationPolicyData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating CancellationPolicy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCancellationPolicy = createAsyncThunk(
  "CancellationPolicies/DeleteCancellationPolicies",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CancellationPolicies/DeleteCancellationPolicies`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting CancellationPolicy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCancellationPolicyByID = createAsyncThunk(
  "CancellationPolicies/FindByIDCancellationPolicies",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CancellationPolicies/FindByIDCancellationPolicies`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        IsActive: result?.IsActive ? 1 : 2,
      } as ICancellationPolicy;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching CancellationPolicy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCancellationPolicy = createAsyncThunk(
  "CancellationPolicies/FindAllActiveCancellationPolicies",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/CancellationPolicies/FindAllActiveCancellationPolicies`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching CancellationPolicy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveCancellationPolicy = createAsyncThunk(
  "CancellationPolicies/ActiveInActiveCancellationPolicies",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/CancellationPolicies/ActiveInActiveCancellationPolicies`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive CancellationPolicy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
